<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-button-goto ttText="payment_new" ttGoto="payment" [ttGotoParms]="{ payment_id: '' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListPayments"></tt-list>
</tt-page>
